import units from "utils/units"
import { BaseElement } from "utils/base-element"
import { parseFloat } from "utils/helpers"
import "./index.scss"

export class TempDiff extends BaseElement {
  value?: number

  constructor() {
    super()
    this.value = parseFloat(this.getAttribute("value"))
    units.onChange(() => this.update())
  }

  connectedCallback() {
    this.addClassName()
    this.update()
  }

  update() {
    this.textContent =
      this.value === undefined ? "—" : units.formatTempDiff(this.value, { withUnits: false })
  }
}

BaseElement.define("temp-diff", TempDiff)
